"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CURRENT_VERSION", {
  enumerable: true,
  get: function get() {
    return _versions.CURRENT_VERSION;
  }
});
Object.defineProperty(exports, "DimensionFieldSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.DimensionFieldSchema;
  }
});
Object.defineProperty(exports, "FilterSchemaV0", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.FilterSchemaV0;
  }
});
Object.defineProperty(exports, "InteractionSchemaV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.InteractionSchemaV1;
  }
});
Object.defineProperty(exports, "KeplerGLSchemaClass", {
  enumerable: true,
  get: function get() {
    return _schemaManager.KeplerGLSchema;
  }
});
Object.defineProperty(exports, "KeplerGlSchema", {
  enumerable: true,
  get: function get() {
    return _schemaManager["default"];
  }
});
Object.defineProperty(exports, "LayerSchemaV0", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.LayerSchemaV0;
  }
});
Object.defineProperty(exports, "Schema", {
  enumerable: true,
  get: function get() {
    return _schema["default"];
  }
});
Object.defineProperty(exports, "SplitMapsSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.SplitMapsSchema;
  }
});
Object.defineProperty(exports, "VERSIONS", {
  enumerable: true,
  get: function get() {
    return _versions.VERSIONS;
  }
});
Object.defineProperty(exports, "datasetSchema", {
  enumerable: true,
  get: function get() {
    return _datasetSchema["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _schemaManager["default"];
  }
});
Object.defineProperty(exports, "filterPropsV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.filterPropsV1;
  }
});
Object.defineProperty(exports, "mapStateSchema", {
  enumerable: true,
  get: function get() {
    return _mapStateSchema["default"];
  }
});
Object.defineProperty(exports, "mapStyleSchema", {
  enumerable: true,
  get: function get() {
    return _mapStyleSchema["default"];
  }
});
Object.defineProperty(exports, "reducerSchema", {
  enumerable: true,
  get: function get() {
    return _schemaManager.reducerSchema;
  }
});
Object.defineProperty(exports, "visStateSchema", {
  enumerable: true,
  get: function get() {
    return _visStateSchema["default"];
  }
});
Object.defineProperty(exports, "visStateSchemaV1", {
  enumerable: true,
  get: function get() {
    return _visStateSchema.visStateSchemaV1;
  }
});
var _schemaManager = _interopRequireWildcard(require("./schema-manager"));
var _versions = require("./versions");
var _visStateSchema = _interopRequireWildcard(require("./vis-state-schema"));
var _datasetSchema = _interopRequireDefault(require("./dataset-schema"));
var _mapStyleSchema = _interopRequireDefault(require("./map-style-schema"));
var _mapStateSchema = _interopRequireDefault(require("./map-state-schema"));
var _schema = _interopRequireDefault(require("./schema"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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